<template>
  <div class="room dehumidifier-room jiashao-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-item main-column-multi-line-1">
        <div class="column-line-top">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
          <SwitchStatusValue class="switch-item" :title="switchTitleFanPressure" :series="switchDataFanPressure" />
        </div>
        <div class="column-line-down">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown11" :series="switchDataDown11" />
        </div>
      </div>

      <div class="main-column-item main-column-multi-line-2">
        <div :class="{ 'column-line-top-s': isTower, 'column-line-top': !isTower }">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
          <div class="column-line-multi-column">
            <div class="column-line-sub-column">
              <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleTop2L" :bold="true" />
              <SwitchStatus class="switch-item" :title="switchTitleWheel1" :series="switchDataWheel1" />
              <SwitchStatus class="switch-item" :title="switchTitleWheel2" :series="switchDataWheel2" />
              <SwitchStatusValue class="switch-item" :title="switchTitleWheel3" :series="switchDataWheel3" />
              <SwitchStatusValue class="switch-item" :title="switchTitleWheel4" :series="switchDataWheel4" />
            </div>
            <div class="column-line-sub-column">
              <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleTop2R" :bold="true" />
              <SwitchStatus class="switch-item" :title="switchTitleProcessFan1" :series="switchDataProcessFan1" />
              <SwitchStatus class="switch-item" :title="switchTitleProcessFan3" :series="switchDataProcessFan3" />
              <SwitchStatusValue class="switch-item" :title="switchTitleProcessFan2" :series="switchDataProcessFan2" />
            </div>
          </div>
        </div>
        <div :class="{ 'column-line-down-l': isTower, 'column-line-down': !isTower }">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown2" :bold="true" />
          <div class="column-line-multi-column">
            <div class="column-line-sub-column">
              <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleDown2L" :bold="true" />
              <SwitchStatusValue class="switch-item" :title="switchTitleTop2L1" :series="switchDataTop2L1" />
              <!-- 再生加热 -->
              <SwitchStatus class="switch-item" :title="switchTitleTop2L2" :series="switchDataTop2L2"
                v-if="!this.isTower" />
              <SwitchStatusValue class="switch-item" :title="switchTitleTop2L5" :series="switchDataTop2L5"
                v-if="!this.isTower" />
              <!-- 一级加热 二级加热 -->
              <SwitchStatus class="switch-item" :title="switchTitleTop2L7" :series="switchDataTop2L7"
                v-if="this.isTower" />
              <SwitchStatusValue class="switch-item" :title="switchTitleTop2L8" :series="switchDataTop2L8"
                v-if="this.isTower" />
              <SwitchStatus class="switch-item" :title="switchTitleTop2L9" :series="switchDataTop2L9"
                v-if="this.isTower" />
              <SwitchStatusValue class="switch-item" :title="switchTitleTop2L10" :series="switchDataTop2L10"
                v-if="this.isTower" />
              <SwitchStatus class="switch-item" :title="switchTitleTop2L3" :series="switchDataTop2L3" />
              <SwitchStatus class="switch-item" :title="switchTitleTop2L6" :series="switchDataTop2L6" />
              <SwitchStatus class="switch-item" :title="switchTitleTop2L4" :series="switchDataTop2L4" />

            </div>
            <div class="column-line-sub-column">
              <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleDown2RB" :bold="true" />
              <SwitchStatusValue class="switch-item" :title="switchTitleRegenerateAir1"
                :series="switchDataRegenerateAir1" />
              <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleDown2R" :bold="true" />
              <SwitchStatusValue class="switch-item" :title="switchTitleRegenerateAir2"
                :series="switchDataRegenerateAir2" />
              <SwitchStatus class="switch-item" :title="switchTitleRegenerateAir4" :series="switchDataRegenerateAir4" />
              <SwitchStatus class="switch-item" :title="switchTitleRegenerateAir5" :series="switchDataRegenerateAir5" />
              <!-- 右侧一级加热 二级加热 -->
              <!-- <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleDown2RC" :bold="true" v-if="this.isTower" /> -->
              <!-- <SwitchStatus class="switch-item" :title="switchTitleTop2L3" :series="switchDataTop2L3" v-if="this.isTower" />
              <SwitchStatus class="switch-item" :title="switchTitleTop2L6" :series="switchDataTop2L6" v-if="this.isTower" />
              <SwitchStatus class="switch-item" :title="switchTitleTop2L4" :series="switchDataTop2L4" v-if="this.isTower" /> -->
            </div>
          </div>
        </div>
      </div>

      <div class="main-column-item main-column-multi-line-3">
        <div :class="{ 'column-line-top-l': isSteelBox, 'column-line-top': !isSteelBox }">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleAirHole1" :series="switchDataAirHole1" />
          <SwitchStatusValue class="switch-item" :title="switchTitleEnvironment1" :series="switchDataEnvironment1" />
          <SwitchStatus class="switch-item" :title="switchTitleAirHole2" :series="switchDataAirHole2" />
          <SwitchStatusValue class="switch-item" :title="switchTitleEnvironment2" :series="switchDataEnvironment2" />
          <SwitchStatus class="switch-item" :title="switchTitleAirHole3" :series="switchDataAirHole3" />
          <SwitchStatusValue class="switch-item" :title="switchTitleEnvironment3" :series="switchDataEnvironment3" />
          <SwitchStatus class="switch-item" :title="switchTitleAirHole4" :series="switchDataAirHole4" v-if="!isTower" />
          <SwitchStatusValue class="switch-item" :title="switchTitleEnvironment4" :series="switchDataEnvironment4"
            v-if="!isTower" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDehumidifier" :series="switchDataDehumidifier"
            v-if="!isRigidHinge" />
        </div>
        <div :class="{ 'column-line-down-s': isSteelBox, 'column-line-down': !isSteelBox }">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown3" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleFilterDehumidifier"
            :series="switchDataFilterDehumidifier" />
        </div>
      </div>

      <div class="main-column-item"
        :class="{ 'main-column-multi-line-rigid-hinge': isRigidHinge, 'main-column-multi-line-4': !isRigidHinge }">
        <div class="column-line-top" v-if="isRigidHinge">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
          <div class="column-line-multi-column">
            <div class="column-line-sub-column">
              <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleTop4L" :bold="true" />
              <SwitchStatus class="switch-item" :title="switchTitleElectricValve1" :series="switchDataElectricValve1" />
              <SwitchStatus class="switch-item" :title="switchTitleElectricValve2" :series="switchDataElectricValve2" />
              <SwitchStatus class="switch-item" :title="switchTitleElectricValve3" :series="switchDataElectricValve3" />
              <SwitchStatus class="switch-item" :title="switchTitleElectricValve4" :series="switchDataElectricValve4" />
              <SwitchStatus class="switch-item" :title="switchTitleTopPressureFan1"
                :series="switchDataTopPressureFan1" />
              <SwitchStatusValue class="switch-item" :title="switchTitleTopPressureFan2"
                :series="switchDataTopPressureFan2" />
            </div>
            <div class="column-line-sub-column">
              <SwitchStatusTitle class="switch-item-sub-title" :title="columnSubtitleTop4R" :bold="true" />
              <SwitchStatusValue class="switch-item" :title="switchTitleControl1" :series="switchDataControl1" />
              <SwitchStatusValue class="switch-item" :title="switchTitleControl2" :series="switchDataControl2" />
              <SwitchStatus class="switch-item" :title="switchTitleControl3" :series="switchDataControl3" />
              <SwitchStatus class="switch-item" :title="switchTitleControl4" :series="switchDataControl4" />
            </div>
          </div>
        </div>
        <div class="column-line-top" v-else>
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleElectricValve1" :series="switchDataElectricValve1" />
          <SwitchStatus class="switch-item" :title="switchTitleElectricValve2" :series="switchDataElectricValve2" />
          <SwitchStatus class="switch-item" :title="switchTitleElectricValve3" :series="switchDataElectricValve3" />
          <SwitchStatus class="switch-item" :title="switchTitleElectricValve4" :series="switchDataElectricValve4"
            v-if="isSteelBox || isRigidHinge" />
          <SwitchStatus class="switch-item" :title="switchTitleTopPressureFan1" :series="switchDataTopPressureFan1" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTopPressureFan2"
            :series="switchDataTopPressureFan2" />
        </div>
        <div class="column-line-down" v-if="isRigidHinge">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown4" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleCooling1" :series="switchDataCooling1" />
          <SwitchStatusValue class="switch-item" :title="switchTitleCooling2" :series="switchDataCooling2" />
          <SwitchStatus class="switch-item" :title="switchTitleCooling3" :series="switchDataCooling3" />
          <SwitchStatusValue class="switch-item" :title="switchTitleCooling4" :series="switchDataCooling4" />
          <SwitchStatus class="switch-item" :title="switchTitleCooling5" :series="switchDataCooling5" />
          <SwitchStatusValue class="switch-item" :title="switchTitleCooling6" :series="switchDataCooling6" />
        </div>
        <div class="column-line-down" v-else>
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown4" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleControl1" :series="switchDataControl1" />
          <SwitchStatusValue class="switch-item" :title="switchTitleControl2" :series="switchDataControl2" />
          <SwitchStatus class="switch-item" :title="switchTitleControl3" :series="switchDataControl3" />
          <SwitchStatus class="switch-item" :title="switchTitleControl4" :series="switchDataControl4" />
          <SwitchStatus class="switch-item" :title="switchTitleControl5" :series="switchDataControl5"
            v-if="!isRigidHinge" />
          <!-- <SwitchStatusValue class="switch-item" :title="switchTitleControl6" :series="switchDataControl6"
            v-if="!isRigidHinge" /> -->
        </div>
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>

<script>
import configJson from "./config/station.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: true,
      stationLocation: "",
      stationName: "",
      stationIndex: "",
      stationVentNameFix: "",

      columnSubtitleDown2L: "再生加热",
      columnSubtitleDown2R: "再生排风",
      columnSubtitleDown2RB: "再生进风",
      columnSubtitleDown2RC: "再生加热报警",
      columnSubtitleTop2L: "转轮",
      columnSubtitleTop2R: "处理风机",
      columnSubtitleTop4L: "循环风",
      columnSubtitleTop4R: "除湿机",

      isRigidHinge: false,
      isSteelBox: false,
      steelBoxSensorLocation1: "",
      steelBoxSensorLocation2: "",
      steelBoxSensorLocation4: "",
      steelBoxSensorLocation5: "",

      switchDataProcessFan1: null,
      switchDataProcessFan2: null,
      switchDataProcessFan3: null,
      switchDataDehumidifier: null,

      switchDataDown11: null,
      switchDataTop11: null,

      switchDataTop2L1: null,
      switchDataTop2L2: null,
      switchDataTop2L3: null,
      switchDataTop2L4: null,
      switchDataTop2L5: null,
      switchDataTop2L6: null,
      switchDataTop2L7: null,
      switchDataTop2L8: null,
      switchDataTop2L9: null,
      switchDataTop2L10: null,

      switchDataWheel1: null,
      switchDataWheel2: null,
      switchDataWheel3: null,
      switchDataWheel4: null,
      switchDataRegenerateAir2: null,
      switchDataRegenerateAir5: null,
      switchDataFanPressure: null,
      switchDataRegenerateAir4: null,

      switchDataTopPressureFan1: null,
      switchDataTopPressureFan2: null,
      switchDataDown23: null,

      switchDataTop31: null,
      switchDataRegenerateAir1: null,
      switchDataFilterDehumidifier: null,

      switchDataControl2: null,
      switchDataControl3: null,
      switchDataControl4: null,
      switchDataControl5: null,
      switchDataControl6: null,
      switchDataControl1: null,
      switchDataTop41A: null,
      switchDataTop41B: null,

      switchDataEnvironment1: null,
      switchDataEnvironment2: null,
      switchDataEnvironment3: null,
      switchDataEnvironment4: null,

      switchDataCooling1: null,
      switchDataCooling2: null,
      switchDataCooling3: null,
      switchDataCooling4: null,
      switchDataCooling5: null,
      switchDataCooling6: null,

      switchDataAirHole1: null,
      switchDataAirHole2: null,
      switchDataAirHole3: null,
      switchDataAirHole4: null,

      switchDataElectricValve1: null,
      switchDataElectricValve2: null,
      switchDataElectricValve3: null,
      switchDataElectricValve4: null,

      warningFlagLeft: "",
      warningFlagRight: "",
      deviceList: [],
      singlePieHistogramWrapData1: null,
      singlePieHistogramWrapData2: null,
      singlePieHistogramWrapData3: null,
      singlePieHistogramWrapData4: null,
      warningFlag1: "",
      warningFlag2: "",
      warningFlag3: "",
      warningFlag4: "",
      humidityLineData: null,
      humidityBarData: null,

      runningTimeDataLeft: null,
      runningTimeDataRight: null,
    };
  },
  computed: {
    isTower: function () {
      return !this.isSteelBox && !this.isRigidHinge
    },

    columnTitlePrefix: function () {
      return this.stationLocation + this.stationIndex + "设备-";
    },
    columnTitleTop1: function () {
      return this.columnTitlePrefix + "送风段";
    },
    columnTitleDown1: function () {
      return this.columnTitlePrefix + "混合段";
    },
    columnTitleTop2: function () {
      return this.columnTitlePrefix + "转轮段";
    },
    columnTitleDown2: function () {
      return this.columnTitlePrefix + "再生热回收段";
    },
    columnTitleTop3: function () {
      return this.columnTitlePrefix + "环境";
    },
    columnTitleDown3: function () {
      return this.columnTitlePrefix + "再生长效过滤段";
    },
    columnTitleTop4: function () {
      if (this.isRigidHinge) {
        return this.columnTitlePrefix + "控制箱";
      } else {
        return this.columnTitlePrefix + "循环风控制箱";
      }
    },
    columnTitleDown4: function () {
      if (this.isRigidHinge) {
        return this.columnTitlePrefix + "冷凝段";
      } else {
        return this.columnTitlePrefix + "除湿机控制箱";
      }
    },

    switchTitleProcessFan1: function () {
      return "处理风机";
    },
    switchTitleProcessFan2: function () {
      return "处理风机";
    },
    switchTitleProcessFan3: function () {
      return "处理风机";
    },

    switchTitleDown11: function () {
      return "回风长效过滤器";
    },
    switchTitleTop11: function () {
      return "除湿机送风";
    },

    switchTitleTop2L1: function () {
      return "再生加热";
    },
    switchTitleTop2L2: function () {
      return "再生加热";
    },
    switchTitleTop2L3: function () {
      return "再生加热温度";
    },
    switchTitleTop2L4: function () {
      return "再生箱温度";
    },
    switchTitleTop2L5: function () {
      return "再生加热";
    },
    switchTitleTop2L6: function () {
      return "再生加热保护";
    },
    switchTitleTop2L7: function () {
      return "一级再生加热";
    },
    switchTitleTop2L8: function () {
      return "一级再生加热";
    },
    switchTitleTop2L9: function () {
      return "二级再生加热";
    },
    switchTitleTop2L10: function () {
      return "二级再生加热";
    },

    switchTitleDehumidifier: function () {
      return "除湿机";
    },

    switchTitleWheel1: function () {
      return "转轮";
    },
    switchTitleWheel2: function () {
      return "减速机";
    },
    switchTitleWheel3: function () {
      return "除湿状态";
    },
    switchTitleWheel4: function () {
      return "转轮";
    },
    switchTitleRegenerateAir2: function () {
      return "再生排风";
    },
    switchTitleRegenerateAir5: function () {
      return "再生排风温度";
    },
    switchTitleFanPressure: function () {
      return "风机状态";
    },
    switchTitleRegenerateAir4: function () {
      return "再生风机";
    },

    switchTitleTopPressureFan1: function () {
      return "加压风机";
    },
    switchTitleTopPressureFan2: function () {
      return "加压风机";
    },
    switchTitleDown23: function () {
      return "加压风机";
    },

    // switchTitleTop31: function () {
    //   return "新风温度";
    // },
    switchTitleRegenerateAir1: function () {
      if (this.isRigidHinge) {
        return "新风";
      } else {
        return "再生进风";
      }
    },
    switchTitleFilterDehumidifier: function () {
      if (this.isRigidHinge) {
        return "新风长效过滤器";
      } else {
        return "除湿长效过滤器";
      }
    },

    switchTitleControl2: function () {
      return "采集电流";
    },
    switchTitleControl3: function () {
      return "除湿机";
    },
    switchTitleControl4: function () {
      return "电源";
    },
    switchTitleControl5: function () {
      return "脱扣器";
    },
    switchTitleControl6: function () {
      return "脱扣器";
    },
    switchTitleControl1: function () {
      if (this.isRigidHinge) {
        return this.stationIndex + "湿度最大值";
      } else {
        return this.stationLocation + "湿度最大值";
      }
    },
    switchTitleTop41A: function () {
      return "电控阀门" + this.stationIndex + "-1-2";
    },
    switchTitleTop41B: function () {
      return "电控阀门" + this.stationIndex + "-3-4";
    },

    switchTitleEnvironment1: function () {
      if (this.isSteelBox) {
        return this.steelBoxSensorLocation1 + "梁段循环风";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-1刚性铰传感器";
      } else {
        return this.stationLocation + "上循环风";
      }
    },
    switchTitleEnvironment2: function () {
      if (this.isSteelBox) {
        return this.steelBoxSensorLocation2 + "梁段循环风";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-2刚性铰传感器";
      } else {
        return this.stationLocation + "中循环风";
      }
    },
    switchTitleEnvironment3: function () {
      if (this.isSteelBox) {
        return this.steelBoxSensorLocation4 + "梁段循环风";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-3刚性铰传感器";
      } else {
        return this.stationLocation + "下循环风";
      }
    },
    switchTitleEnvironment4: function () {
      if (this.isSteelBox) {
        return this.steelBoxSensorLocation5 + "梁段循环风";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-4刚性铰传感器";
      } else {
        return this.stationLocation + "";
      }
    },

    switchTitleAirHole1: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-1风孔";
      } else if (this.isRigidHinge) {
        return "刚性铰" + this.stationIndex + "-1风孔";
      } else {
        return this.stationLocation + this.stationIndex + "-1风孔";
      }
    },
    switchTitleAirHole2: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-2风孔";
      } else if (this.isRigidHinge) {
        return "刚性铰" + this.stationIndex + "-2风孔";
      } else {
        return this.stationLocation + this.stationIndex + "-2风孔";
      }
    },
    switchTitleAirHole3: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-3风孔";
      } else if (this.isRigidHinge) {
        return "刚性铰" + this.stationIndex + "-3风孔";
      } else {
        return this.stationLocation + this.stationIndex + "-3风孔";
      }
    },
    switchTitleAirHole4: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-4风孔";
      } else if (this.isRigidHinge) {
        return "刚性铰" + this.stationIndex + "-4风孔";
      } else {
        return "--";
      }
    },

    switchTitleElectricValve1: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-1电控阀门";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-1电控阀门";
      } else {
        return this.stationLocation + this.stationIndex + "-1电控阀门";
      }
    },
    switchTitleElectricValve2: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-2电控阀门";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-2电控阀门";
      } else {
        return this.stationLocation + this.stationIndex + "-2电控阀门";
      }
    },
    switchTitleElectricValve3: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-3电控阀门";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-3电控阀门";
      } else {
        return this.stationLocation + this.stationIndex + "-3电控阀门";
      }
    },
    switchTitleElectricValve4: function () {
      if (this.isSteelBox) {
        return "钢箱梁" + this.stationIndex + "-4电控阀门";
      } else if (this.isRigidHinge) {
        return this.stationIndex + "-4电控阀门";
      } else {
        return "--";
      }
    },

    switchTitleCooling1: function () {
      return "降温状态传感器";
    },
    switchTitleCooling2: function () {
      return "盘管";
    },
    switchTitleCooling3: function () {
      return "前表";
    },
    switchTitleCooling4: function () {
      return "前表";
    },
    switchTitleCooling5: function () {
      return "前表电磁阀霜化";
    },
    switchTitleCooling6: function () {
      return "前表电磁阀霜化";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationId = configJson[routerName].stationId;
      this.stationLocation = configJson[routerName].stationLocation;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;

      this.isRigidHinge = configJson[routerName].isRigidHinge;
      this.isSteelBox = configJson[routerName].isSteelBox;
      this.steelBoxSensorLocation1 = configJson[routerName].steelBoxSensorLocation1;
      this.steelBoxSensorLocation2 = configJson[routerName].steelBoxSensorLocation2;
      this.steelBoxSensorLocation4 = configJson[routerName].steelBoxSensorLocation4;
      this.steelBoxSensorLocation5 = configJson[routerName].steelBoxSensorLocation5;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      // this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        const switchIdProcessFan1 = this.findDeviceId(this.switchTitleProcessFan1 + "运行");
        const switchIdProcessFan2 = this.findDeviceId(this.switchTitleProcessFan2 + "运行时间");
        const switchIdProcessFan3 = this.findDeviceId(this.switchTitleProcessFan3 + "缺风保护");
        const switchIdFanPressure = this.findDeviceId(this.switchTitleFanPressure.replace("风机状态", "再生风机风压"));
        this.switchDataFanPressure = {
          data: currentData[switchIdFanPressure].value,
          isError: currentData[switchIdFanPressure].errorLevel,
          unit: "Pa",
        };
        this.switchDataProcessFan1 = {
          data: currentData[switchIdProcessFan1].value,
          isError: currentData[switchIdProcessFan1].errorLevel,
        };
        this.switchDataProcessFan2 = {
          data: currentData[switchIdProcessFan2].value,
          isError: currentData[switchIdProcessFan2].errorLevel,
          isRunningTime: true,
        };
        this.switchDataProcessFan3 = {
          data: currentData[switchIdProcessFan3].value,
          isError: currentData[switchIdProcessFan3].errorLevel,
          isZh: true,
          textOn: "缺风",
        };

        const switchIdPressureFan1 = this.findDeviceId(this.switchTitleTopPressureFan1 + "运行");
        const switchIdPressureFan2 = this.findDeviceId(this.switchTitleTopPressureFan2 + "运行时间");
        this.switchDataTopPressureFan1 = {
          data: currentData[switchIdPressureFan1].value,
          isError: currentData[switchIdPressureFan1].errorLevel,
        };
        this.switchDataTopPressureFan2 = {
          data: currentData[switchIdPressureFan2].value,
          isError: currentData[switchIdPressureFan2].errorLevel,
          isRunningTime: true,
        };

        if (!this.isRigidHinge) {
          const switchIdDehumidifierT = this.findDeviceId(this.switchTitleDehumidifier + "传感器温度");
          const switchIdDehumidifierH = this.findDeviceId(this.switchTitleDehumidifier + "传感器湿度");
          const switchIdDehumidifierA = this.findDeviceId(this.switchTitleDehumidifier + "传感器含湿量");
          this.switchDataDehumidifier = [
            {
              data: currentData[switchIdDehumidifierH].value,
              isError: currentData[switchIdDehumidifierH].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdDehumidifierT].value,
              isError: currentData[switchIdDehumidifierT].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdDehumidifierA].value,
              isError: currentData[switchIdDehumidifierA].errorLevel,
              unit: "g/kg",
            },
          ];
        }

        const switchIdTop11 = this.findDeviceId(this.switchTitleTop11 + "湿度");
        const switchIdTop11B = this.findDeviceId(this.switchTitleTop11 + "温度");
        const switchIdTop11C = this.findDeviceId(this.switchTitleTop11 + "含湿量");
        this.switchDataTop11 = [
          {
            data: currentData[switchIdTop11].value,
            isError: currentData[switchIdTop11].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop11B].value,
            isError: currentData[switchIdTop11B].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop11C].value,
            isError: currentData[switchIdTop11C].errorLevel,
            unit: "g/kg",
          },
        ];

        const switchIdDown11 = this.findDeviceId(this.switchTitleDown11.replace("长效过滤器", "过滤压差"));
        this.switchDataDown11 = {
          data: currentData[switchIdDown11].value,
          isError: currentData[switchIdDown11].errorLevel,
          unit: "Pa",
        };


        const switchIdTop2L1 = this.findDeviceId(this.switchTitleTop2L1 + "温度");

        const switchIdTop2L3 = this.findDeviceId(this.switchTitleTop2L3.replace("温度", "超温保护"));
        const switchIdTop2L4 = this.findDeviceId(this.switchTitleTop2L4.replace("温度", "超温报警"));

        const switchIdTop2L6 = this.findDeviceId(this.switchTitleTop2L6.replace("保护", "干保护"));
        this.switchDataTop2L1 = {
          data: currentData[switchIdTop2L1].value,
          isError: currentData[switchIdTop2L1].errorLevel,
          unit: "℃",
        };
        this.switchDataTop2L3 = {
          data: currentData[switchIdTop2L3].value,
          isError: currentData[switchIdTop2L3].errorLevel,
          isZh: true,
          textOn: "超温",
        };
        this.switchDataTop2L4 = {
          data: currentData[switchIdTop2L4].value,
          isError: currentData[switchIdTop2L4].errorLevel,
          isZh: true,
        };

        this.switchDataTop2L6 = {
          data: currentData[switchIdTop2L6].value,
          isError: currentData[switchIdTop2L6].errorLevel,
          isZh: true,
          textOn: "干保护",
        };


        //再生加热
        if (!this.isTower) {
          const switchIdTop2L2 = this.findDeviceId(this.switchTitleTop2L2 + "运行");
          const switchIdTop2L5 = this.findDeviceId(this.switchTitleTop2L5 + "运行时间");

          this.switchDataTop2L2 = {
            data: currentData[switchIdTop2L2].value,
            isError: currentData[switchIdTop2L2].errorLevel,
          };
          this.switchDataTop2L5 = {
            data: currentData[switchIdTop2L5].value,
            isError: currentData[switchIdTop2L5].errorLevel,
            isRunningTime: true,
          };
        }
        if (this.isTower) {
          const switchIdTop2L7 = this.findDeviceId(this.switchTitleTop2L7);
          const switchIdTop2L8 = this.findDeviceId(this.switchTitleTop2L8 + "运行时间");
          const switchIdTop2L9 = this.findDeviceId(this.switchTitleTop2L9);
          const switchIdTop2L10 = this.findDeviceId(this.switchTitleTop2L10 + "运行时间");

          this.switchDataTop2L7 = {
            data: currentData[switchIdTop2L7].value,
            isError: currentData[switchIdTop2L7].errorLevel,
          };
          this.switchDataTop2L8 = {
            data: currentData[switchIdTop2L8].value,
            isError: currentData[switchIdTop2L8].errorLevel,
            isRunningTime: true,
          };
          this.switchDataTop2L9 = {
            data: currentData[switchIdTop2L9].value,
            isError: currentData[switchIdTop2L9].errorLevel,
          };
          this.switchDataTop2L10 = {
            data: currentData[switchIdTop2L10].value,
            isError: currentData[switchIdTop2L10].errorLevel,
            isRunningTime: true,
          };
        }


        const switchIdRegenerateAir1 = this.findDeviceId(this.switchTitleRegenerateAir1 + "温度");
        const switchIdRegenerateAir2 = this.findDeviceId(this.switchTitleRegenerateAir2 + "温度");
        const switchIdRegenerateAir5 = this.findDeviceId(this.switchTitleRegenerateAir5.replace("温度", "超温保护"));
        const switchIdRegenerateAir4 = this.findDeviceId(this.switchTitleRegenerateAir4 + "过载");
        this.switchDataRegenerateAir1 = {
          data: currentData[switchIdRegenerateAir1].value,
          isError: currentData[switchIdRegenerateAir1].errorLevel,
          unit: "℃",
        };
        this.switchDataRegenerateAir2 = {
          data: currentData[switchIdRegenerateAir2].value,
          isError: currentData[switchIdRegenerateAir2].errorLevel,
          unit: "℃",
        };
        this.switchDataRegenerateAir5 = {
          data: currentData[switchIdRegenerateAir5].value,
          isError: currentData[switchIdRegenerateAir5].errorLevel,
          isZh: true,
          textOn: "超温",
        };
        this.switchDataRegenerateAir4 = {
          data: currentData[switchIdRegenerateAir4].value,
          isError: currentData[switchIdRegenerateAir4].errorLevel,
          isZh: true,
          textOn: "过载",
        };

        const switchIdWheel1 = this.findDeviceId("再生" + this.switchTitleWheel1 + "运行");
        const switchIdWheel2 = this.findDeviceId(this.switchTitleWheel2 + "过载");
        const switchIdWheel3 = this.findDeviceId(this.switchTitleWheel3.replace("除湿状态", "转轮计数"));
        const switchIdWheel4 = this.findDeviceId("再生" + this.switchTitleWheel4 + "运行时间");
        this.switchDataWheel1 = {
          data: currentData[switchIdWheel1].value,
          isError: currentData[switchIdWheel1].errorLevel,
        };
        this.switchDataWheel2 = {
          data: currentData[switchIdWheel2].value,
          isError: currentData[switchIdWheel2].errorLevel,
          isZh: true,
          textOn: "过载",
        };
        this.switchDataWheel3 = {
          data: currentData[switchIdWheel3].value,
          isError: currentData[switchIdWheel3].errorLevel,
          unit: "圈",
        };
        this.switchDataWheel4 = {
          data: currentData[switchIdWheel4].value,
          isError: currentData[switchIdWheel4].errorLevel,
          isRunningTime: true,
        };

        const switchIdFilterDehumidifier = this.findDeviceId(this.switchTitleFilterDehumidifier.replace("长效过滤器", "过滤压差"));
        this.switchDataFilterDehumidifier = {
          data: currentData[switchIdFilterDehumidifier].value,
          isError: currentData[switchIdFilterDehumidifier].errorLevel,
          unit: "Pa",
        };

        const switchIdControl2 = this.findDeviceId("除湿机" + this.switchTitleControl2);
        const switchIdControl3 = this.findDeviceId(this.switchTitleControl3 + "报警");
        const switchIdControl4 = this.findDeviceId(this.switchTitleControl4 + "故障");
        const switchIdControl1 = this.findDeviceId("传感器湿度最大值");
        this.switchDataControl1 = {
          data: currentData[switchIdControl1].value,
          isError: currentData[switchIdControl1].errorLevel,
          unit: "%",
        };
        this.switchDataControl2 = {
          data: currentData[switchIdControl2].value,
          isError: currentData[switchIdControl2].errorLevel,
          unit: "A",
        };
        this.switchDataControl3 = {
          data: currentData[switchIdControl3].value,
          isError: currentData[switchIdControl3].errorLevel,
          isZh: true,
          textOn: "报警",
        };
        this.switchDataControl4 = {
          data: currentData[switchIdControl4].value,
          isError: currentData[switchIdControl4].errorLevel,
          isZh: true,
          textOn: "故障",
        };

        if (!this.isRigidHinge) {
          const switchIdControl5 = this.findDeviceId(this.switchTitleControl5);
          // const switchIdControl6 = this.findDeviceId(this.switchTitleControl6 + "运行时间");
          this.switchDataControl5 = {
            data: currentData[switchIdControl5].value,
            isError: currentData[switchIdControl5].errorLevel,
            isZh: true,
            textOn: "脱扣",
          };
          // this.switchDataControl6 = {
          //   data: currentData[switchIdControl6].value,
          //   isError: currentData[switchIdControl6].errorLevel,
          //   isRunningTime: true,
          // };
        }

        const switchIdTopAirHole1 = this.findDeviceId("电控阀门1-2");
        const switchIdTopAirHole2 = this.findDeviceId("电控阀门1-2");
        const switchIdTopAirHole3 = this.findDeviceId("电控阀门3-4");
        const switchIdTopAirHole4 = this.findDeviceId("电控阀门3-4");
        this.switchDataAirHole1 = {
          data: currentData[switchIdTopAirHole1].value,
          isError: currentData[switchIdTopAirHole1].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataAirHole2 = {
          data: currentData[switchIdTopAirHole2].value,
          isError: currentData[switchIdTopAirHole2].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataAirHole3 = {
          data: currentData[switchIdTopAirHole3].value,
          isError: currentData[switchIdTopAirHole3].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataAirHole4 = {
          data: currentData[switchIdTopAirHole4].value,
          isError: currentData[switchIdTopAirHole4].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };

        const switchIdTopElectricValve1 = this.findDeviceId("电控阀门1-2");
        const switchIdTopElectricValve2 = this.findDeviceId("电控阀门1-2");
        const switchIdTopElectricValve3 = this.findDeviceId("电控阀门3-4");
        const switchIdTopElectricValve4 = this.findDeviceId("电控阀门3-4");
        this.switchDataElectricValve1 = {
          data: currentData[switchIdTopElectricValve1].value,
          isError: currentData[switchIdTopElectricValve1].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataElectricValve2 = {
          data: currentData[switchIdTopElectricValve2].value,
          isError: currentData[switchIdTopElectricValve2].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataElectricValve3 = {
          data: currentData[switchIdTopElectricValve3].value,
          isError: currentData[switchIdTopElectricValve3].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataElectricValve4 = {
          data: currentData[switchIdTopElectricValve4].value,
          isError: currentData[switchIdTopElectricValve4].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };

        if (this.isSteelBox) {
          const switchIdEnvironment1T = this.findDeviceId("循环风1温度");
          const switchIdEnvironment1H = this.findDeviceId("循环风1湿度");
          const switchIdEnvironment1A = this.findDeviceId("循环风1含湿量");
          const switchIdEnvironment2T = this.findDeviceId("循环风2温度");
          const switchIdEnvironment2H = this.findDeviceId("循环风2湿度");
          const switchIdEnvironment2A = this.findDeviceId("循环风2含湿量");
          const switchIdEnvironment3T = this.findDeviceId("循环风4温度");
          const switchIdEnvironment3H = this.findDeviceId("循环风4湿度");
          const switchIdEnvironment3A = this.findDeviceId("循环风4含湿量");
          const switchIdEnvironment4T = this.findDeviceId("循环风5温度");
          const switchIdEnvironment4H = this.findDeviceId("循环风5湿度");
          const switchIdEnvironment4A = this.findDeviceId("循环风5含湿量");

          this.switchDataEnvironment1 = [
            {
              data: currentData[switchIdEnvironment1H].value,
              isError: currentData[switchIdEnvironment1H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment1T].value,
              isError: currentData[switchIdEnvironment1T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment1A].value,
              isError: currentData[switchIdEnvironment1A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment2 = [
            {
              data: currentData[switchIdEnvironment2H].value,
              isError: currentData[switchIdEnvironment2H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment2T].value,
              isError: currentData[switchIdEnvironment2T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment2A].value,
              isError: currentData[switchIdEnvironment2A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment3 = [
            {
              data: currentData[switchIdEnvironment3H].value,
              isError: currentData[switchIdEnvironment3H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment3T].value,
              isError: currentData[switchIdEnvironment3T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment3A].value,
              isError: currentData[switchIdEnvironment3A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment4 = [
            {
              data: currentData[switchIdEnvironment4H].value,
              isError: currentData[switchIdEnvironment4H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment4T].value,
              isError: currentData[switchIdEnvironment4T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment4A].value,
              isError: currentData[switchIdEnvironment4A].errorLevel,
              unit: "g/kg",
            },
          ];
        } else if (this.isRigidHinge) {
          const switchIdEnvironment1T = this.findDeviceId("循环风1温度");
          const switchIdEnvironment1H = this.findDeviceId("循环风1湿度");
          const switchIdEnvironment1A = this.findDeviceId("循环风1含湿量");
          const switchIdEnvironment2T = this.findDeviceId("循环风2温度");
          const switchIdEnvironment2H = this.findDeviceId("循环风2湿度");
          const switchIdEnvironment2A = this.findDeviceId("循环风2含湿量");
          const switchIdEnvironment3T = this.findDeviceId("循环风3温度");
          const switchIdEnvironment3H = this.findDeviceId("循环风3湿度");
          const switchIdEnvironment3A = this.findDeviceId("循环风3含湿量");
          const switchIdEnvironment4T = this.findDeviceId("循环风4温度");
          const switchIdEnvironment4H = this.findDeviceId("循环风4湿度");
          const switchIdEnvironment4A = this.findDeviceId("循环风4含湿量");
          this.switchDataEnvironment1 = [
            {
              data: currentData[switchIdEnvironment1H].value,
              isError: currentData[switchIdEnvironment1H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment1T].value,
              isError: currentData[switchIdEnvironment1T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment1A].value,
              isError: currentData[switchIdEnvironment1A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment2 = [
            {
              data: currentData[switchIdEnvironment2H].value,
              isError: currentData[switchIdEnvironment2H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment2T].value,
              isError: currentData[switchIdEnvironment2T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment2A].value,
              isError: currentData[switchIdEnvironment2A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment3 = [
            {
              data: currentData[switchIdEnvironment3H].value,
              isError: currentData[switchIdEnvironment3H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment3T].value,
              isError: currentData[switchIdEnvironment3T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment3A].value,
              isError: currentData[switchIdEnvironment3A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment4 = [
            {
              data: currentData[switchIdEnvironment4H].value,
              isError: currentData[switchIdEnvironment4H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment4T].value,
              isError: currentData[switchIdEnvironment4T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment4A].value,
              isError: currentData[switchIdEnvironment4A].errorLevel,
              unit: "g/kg",
            },
          ];
        } else {
          const switchIdEnvironment1T = this.findDeviceId("上循环风温度");
          const switchIdEnvironment1H = this.findDeviceId("上循环风湿度");
          const switchIdEnvironment1A = this.findDeviceId("上循环风含湿量");
          const switchIdEnvironment2T = this.findDeviceId("中循环风温度");
          const switchIdEnvironment2H = this.findDeviceId("中循环风湿度");
          const switchIdEnvironment2A = this.findDeviceId("中循环风含湿量");
          const switchIdEnvironment3T = this.findDeviceId("下循环风温度");
          const switchIdEnvironment3H = this.findDeviceId("下循环风湿度");
          const switchIdEnvironment3A = this.findDeviceId("下循环风含湿量");
          this.switchDataEnvironment1 = [
            {
              data: currentData[switchIdEnvironment1H].value,
              isError: currentData[switchIdEnvironment1H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment1T].value,
              isError: currentData[switchIdEnvironment1T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment1A].value,
              isError: currentData[switchIdEnvironment1A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment2 = [
            {
              data: currentData[switchIdEnvironment2H].value,
              isError: currentData[switchIdEnvironment2H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment2T].value,
              isError: currentData[switchIdEnvironment2T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment2A].value,
              isError: currentData[switchIdEnvironment2A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment3 = [
            {
              data: currentData[switchIdEnvironment3H].value,
              isError: currentData[switchIdEnvironment3H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdEnvironment3T].value,
              isError: currentData[switchIdEnvironment3T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdEnvironment3A].value,
              isError: currentData[switchIdEnvironment3A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataEnvironment4 = [
            {
              data: "--",
              isError: "Warning",
              unit: "%",
            },
            {
              data: "--",
              isError: "Warning",
              unit: "℃",
            },
          ];
        }

        if (this.isRigidHinge) {
          const switchIdCooling1 = this.findDeviceId(this.switchTitleCooling1 + "温度");
          const switchIdCooling2 = this.findDeviceId(this.switchTitleCooling2 + "温度");
          const switchIdCooling3 = this.findDeviceId(this.switchTitleCooling3 + "运行");
          const switchIdCooling4 = this.findDeviceId(this.switchTitleCooling4 + "运行时间");
          const switchIdCooling5 = this.findDeviceId(this.switchTitleCooling5);
          const switchIdCooling6 = this.findDeviceId(this.switchTitleCooling6 + "运行时间");
          this.switchDataCooling1 = {
            data: currentData[switchIdCooling1].value,
            isError: currentData[switchIdCooling1].errorLevel,
            unit: "℃",
          };
          this.switchDataCooling2 = {
            data: currentData[switchIdCooling2].value,
            isError: currentData[switchIdCooling2].errorLevel,
            unit: "℃",
          };
          this.switchDataCooling3 = {
            data: currentData[switchIdCooling3].value,
            isError: currentData[switchIdCooling3].errorLevel,
          };
          this.switchDataCooling4 = {
            data: currentData[switchIdCooling4].value,
            isError: currentData[switchIdCooling4].errorLevel,
            isRunningTime: true,
          };
          this.switchDataCooling5 = {
            data: currentData[switchIdCooling5].value,
            isError: currentData[switchIdCooling5].errorLevel,
          };
          this.switchDataCooling6 = {
            data: currentData[switchIdCooling6].value,
            isError: currentData[switchIdCooling6].errorLevel,
            isRunningTime: true,
          };
        }
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  // & div {
  //   border: 1px solid;
  // }

  &.jiashao-room {
    width: calc(100% - 50px) !important
  }

  .dehumidifier-main {
    width: 100%;
    height: 100%;
    // min-width: 1270px;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 7px);
    min-height: 320px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-top {
    width: 100%;
    height: calc(52% - 7px);
    // min-height: 435px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-top-s {
    width: 100%;
    height: calc(40% - 7px);
    // min-height: 435px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-top-l {
    width: 100%;
    height: calc(58% - 7px);
    // min-height: 435px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-down {
    width: 100%;
    height: calc(48% - 7px);
    // min-height: 275px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-down-l {
    width: 100%;
    height: calc(60% - 7px);
    // min-height: 275px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-down-s {
    width: 100%;
    height: calc(42% - 7px);
    // min-height: 275px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-sub-column {
    width: calc(50%);
    height: 100%;
  }

  .column-line-multi-column {
    width: 100%;

    display: flex;
  }

  .main-column {
    width: calc(100% / 7 + 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-item {
    min-height: 710px;
  }

  .main-column-multi-line-3 {
    width: calc(100% / 4 - 30px);
    height: 100%;
    border-color: yellow;
    min-width: 365px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-column-multi-line-4 {
    width: calc(100% / 4 - 30px);
    height: 100%;
    border-color: yellow;
    min-width: 310px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-column-multi-line-rigid-hinge {
    width: calc(100% / 4 - 30px);
    height: 100%;
    border-color: yellow;
    min-width: 400px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-column-multi-line-1 {
    width: calc(100% / 4 - 70px);
    height: 100%;
    border-color: yellow;
    min-width: 305px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-column-multi-line-2 {
    width: calc(100% / 4 + 90px);
    height: 100%;
    border-color: yellow;
    min-width: 440px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item-sub-title {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }
}
</style>